module.exports = __webpack_public_path__ + "static/media/Onboarding-MapadeAprendizagem2x.0ef50ad2.png";